(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsController", SavingsController);

    /** @ngInject */
    function SavingsController($scope, $translate, SavingsViewModel, savingsActions, dialogsService) {
        var vm = this;

        vm.savings = new SavingsViewModel();
        vm.isLoading = false;
        vm.savingsUsers = [];
        vm.searchFilter = '';

        vm.filterSavings = filterSavings;
        vm.printSavings = printSavings;
        vm.deactivateSavings = deactivateSavings;
        vm.pageChanged = pageChanged;
        vm.sortChanged = sortChanged;

        // Initialize
        activate();

        function activate() {
            getSavingsUsers();
        }

        function getSavingsUsers() {
            vm.isLoading = true;
            savingsActions.getSavingsUsers(
                vm.savings.page,
                vm.savings.pageSize,
                vm.savings.orderBy,
                vm.savings.order,
                vm.searchFilter
            ).then(function (data) {
                vm.savingsUsers = data.content || [];
                vm.savings.total = data.totalElements || 0;
                vm.isLoading = false;
            }).catch(function (error) {
                vm.isLoading = false;
                console.error('Error loading savings users:', error);
            });
        }

        function filterSavings() {
            vm.savings.page = 1;
            getSavingsUsers();
        }

        function pageChanged(page, limit) {
            vm.savings.paginationChanged(page, limit);
            getSavingsUsers();
        }

        function sortChanged(order) {
            vm.savings.sortChanged(order);
            getSavingsUsers();
        }

        function printSavings(savingsUser) {
            vm.savingsForPrint = [savingsUser];
            setTimeout(function () {
                window.print();
            }, 100);
        }

        function deactivateSavings(savingsUser) {
            dialogsService.showConfirmDialog(
                $translate.instant('SAVINGS_DEACTIVATE_TITLE'),
                $translate.instant('SAVINGS_DEACTIVATE_MESSAGE'),
                $translate.instant('YES'),
                $translate.instant('NO')
            ).then(function () {
                savingsActions.deactivateSavingsAccount(savingsUser.accountId).then(function () {
                    getSavingsUsers();
                }).catch(function (error) {
                    console.error('Error deactivating savings account:', error);
                });
            });
        }
    }
})();
